import { Evaluation } from "@/components/ui/icons";
import { useUser } from "@/context/user-context";
import { Report } from "@/types/evaluate";
import {
  CalendarIcon,
  ClipboardCheckIcon,
  DatabaseIcon,
  TrashIcon,
} from "@heroicons/react/outline";
import moment from "moment";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Card } from "../ui/Cards/Card";
import { DropdownMenuVariant } from "../DropdownMenu";
import { DeleteReport } from "./DeleteReport";
import { MetadataItem } from "../ui/Cards/Card/CardMetadata";

export const BlueprintCard = ({ report }: { report: Report }) => {
  const momentsAgo = moment(report.updated_at).fromNow();
  const userContext = useUser();
  const { workspaceId } = useParams();
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const metadata: MetadataItem[] = [
    {
      text: momentsAgo,
      icon: CalendarIcon,
      tooltip: `Last updated ${moment(report.updated_at).format(
        "MMMM D, YYYY [at] h:mm A",
      )}`,
    },
    {
      text: report.dataset_group_name,
      maxWidth: 170,
      icon: DatabaseIcon,
    },
  ];

  if (report.children_report_count > 0) {
    metadata.push({
      text: `${report.children_report_count} run${
        report.children_report_count !== 1 ? "s" : ""
      }`,
      icon: ClipboardCheckIcon,
    });
  }

  const actions = [
    {
      id: "open-dataset-in-new-tab",
      label: `Open ${report.dataset_group_name} in new tab`,
      icon: DatabaseIcon,
      variant: DropdownMenuVariant.PRIMARY,
      onClick: () =>
        window.open(
          `/workspace/${workspaceId}/dataset-groups/${report.dataset_group_id}/dataset/${report.dataset_id}`,
          "_blank",
        ),
    },
    {
      id: "archive-eval",
      label: `Archive`,
      icon: TrashIcon,
      variant: DropdownMenuVariant.DESTRUCTIVE,
      onClick: () => setIsDeleteConfirmationOpen(true),
    },
  ];

  return (
    <>
      <Card
        item={report}
        actions={actions}
        link={`/workspace/${userContext?.activeWorkspaceId}/evaluate/blueprints/${report.id}`}
        title={report.name}
        icon={<Evaluation className="h-[22px] w-[22px] text-gray-400" />}
        metadata={metadata}
      />
      <DeleteReport
        open={isDeleteConfirmationOpen}
        setOpen={setIsDeleteConfirmationOpen}
        reportName={report.name}
        reportId={report.id}
      />
    </>
  );
};
